export const fetchMarketRevenueDetailsURL = (search) => {
  return `/finance/market-revenue-missing?${search}`;
};

export const fetchCustomerDetailsByIdURL = () => {
  return `/customer/dialogue-details`;
};

export const fetchRevenueCustomerTripsURL = (
  customerId,
  {business_segment_list},
) => {
  if (!business_segment_list) {
    return `/finance/missing-revenue-trips/${customerId}`;
  } else {
    if (business_segment_list.length === 1) {
      return `/finance/missing-revenue-trips/${customerId}?business_segment_list=${business_segment_list[0]}`;
    }
    if (business_segment_list.length === 2) {
      return `/finance/missing-revenue-trips/${customerId}?business_segment_list=${business_segment_list[0]}&business_segment_list=${business_segment_list[1]}`;
    }
    if (business_segment_list.length === 3) {
      return `/finance/missing-revenue-trips/${customerId}?business_segment_list=${business_segment_list[0]}&business_segment_list=${business_segment_list[1]}&business_segment_list=${business_segment_list[2]}`;
    }
  }
};

export const saveRevenueCustomerTripURL = () => {
  return `/finance/add-market-revenue`;
};

export const fetchRevenueAddedTripsURL = (search) => {
  return `/finance/trips-revenue-added?${search}`;
};

export const saveRevenueAddedTripURL = () => {
  return `/finance/edit-market-revenue`;
};

export const revenueSubmitBillingURL = () => {
  return `/finance/send-for-billing`;
};

export const fetchRateMatrixCostURL = () => {
  return `/booking/cost`;
};

export const fetchRateMatrixRouteMarginURL = () => {
  return `/booking/routemargin`;
};

export const fetchRateMatrixReturnRouteURL = () => {
  return `/booking/returnrate`;
};

export const fetchRateMatrixForwardRouteURL = () => {
  return `/booking/forwardrouterate`;
};

export const uploadRouteMarginURL = () => {
  return `/booking/routemargin`;
};

export const uploadReturnRouteURL = () => {
  return `/booking/returnrate`;
};

export const uploadCostURL = () => {
  return `/booking/cost`;
};

//REVENUE BASE RATES
export const createRevenueBaseRateURL = () => {
  return `/finance/revenue-base-rate/`;
};

export const fetchRevenueBaseRatesURL = (page, search) => {
  return `/finance/revenue-base-rate/?page=${page}${search}`;
};

export const editRevenueBaseRateURL = (baseRateId) => {
  return `/finance/revenue-base-rate/${baseRateId}/`;
};

export const downloadBaseRateReportURL = () => {
  return `/finance/revenue-base-rate/download/`;
};

//revenue trips
export const downloadRevenueTripsReportURL = () => {
  return `/finance/trip-revenue/download/`;
};

export const searchRevenueTripsDataURL = () => {
  return `/finance/trip-revenue/initial/`;
};

export const getSearchRevenueTripsDataURL = (page) => {
  return `/finance/trip-revenue/search/`;
};

export const getSearchVendorTripsDataURL = (page) => {
  return `/finance/cost-trip/search/`;
};

export const editTripRevenueURL = () => {
  return `/finance/trip-revenue/`;
};

export const editTripCostURL = (id) => {
  return `/finance/cost-trip/${id}/`;
};

export const updateDieselRateURL = () => {
  return `/finance/trip-revenue/update_diesel_rate/`;
};

export const updateCostDieselRateURL = () => {
  return `finance/cost-trip/update_diesel_rate/`;
};

export const getBaseRateToApplyURL = (customer, route, tripIds) => {
  return `/finance/trip-revenue/get_base_rate/?customer_id=${customer}&route=${route}&trip_ids=${tripIds}`;
};

export const applyBaseRateURL = () => {
  return '/finance/trip-revenue/apply_base_rate/';
};

export const getDetentionDaysURL = (tripId, returnTripId) => {
  return `/finance/detention-days?forward_trip_id=${tripId}`;
};

export const getVendorDetentionDaysURL = (tripId, returnTripId) => {
  return `/finance/cost-detention-days?trip_id=${tripId}`;
};

export const postVendorDetentionDaysURL = (tripId, returnTripId) => {
  return `finance/cost-detention-days`;
};

export const editDetentionDaysURL = () => {
  return `/finance/detention-days`;
};

export const editTripRevenueReferenceURL = () => {
  return `/finance/edit-trip-refrence`;
};

export const createAnnexureURL = () => {
  return `/finance/annexure/`;
};

export const createCostAnnexureURL = () => {
  return `/finance/cost-trip/`;
};

export const viewAnnexureURL = () => {
  return `/finance/annexure/view_annexure/`;
};

export const viewCostAnnexureURL = () => {
  return `/finance/cost-trip/view_annexure/`;
};

//regularization
export const fetchCustomerMappedInvoiceDataURL = (
  customer_id,
  customer_config_id,
  invoice_type,
) => {
  const params = new URLSearchParams();

  if (customer_id != null) params.append('customer_id', customer_id);
  if (customer_config_id != null)
    params.append('customer_config_id', customer_config_id);
  if (invoice_type != null) params.append('invoice_type', invoice_type);
  const queryString = params.toString();
  return `/customer/customer-regularization/${
    queryString ? `?${queryString}` : ''
  }`;
};

export const saveRegularizationDataURL = () => {
  return `/customer/customer-regularization/`;
};

//delta invoicing
export const getDeltaInvoicingDataURL = () => {
  return `/customer/delta-invoicing/get_invoice_data/`;
};

export const generateDeltaInvoiceURL = () => {
  return `/customer/delta-invoicing/generate_invoice/`;
};

export const rejectVerifyInvoiceURL = () => {
  return `/customer/delta-invoicing/invoice_action/`;
};

//invoice qc

// export const getOrderInvoiceQCURL = (orderId) => {
//   return `/customer/invoice-qc?order_id=${orderId}`;
// };

export const getOrderInvoiceQCURL = ({
  order_id,
  invoice_config_id,
  customer_id,
  customer_config_id,
  invoice_status,
}) => {
  const params = new URLSearchParams({
    order_id,
    invoice_config_id,
    customer_id,
    customer_config_id,
    invoice_status,
  });
  return `/customer/invoice-qc?${params.toString()}`;
};

//test rule
export const fetchTestRuleDataURL = (search_Id) => {
  return `/booking/indent-order-test-rules${
    search_Id ? `?search_id=${search_Id}` : ''
  }`;
};

//invoice config
export const addCustomerInvoiceConfigURL = () => {
  return `/customer/customer-invoice-configuration/`;
};

export const fetchInitialInvoiceCustomersURL = (search) => {
  return search
    ? `/customer/customer-invoice-configuration/?name=${search}`
    : `/customer/customer-invoice-configuration/`;
};

export const getCustomerInvoiceConfigsURL = (customerId) => {
  return `/customer/customer-invoice-configuration/${customerId}/`;
};

export const getInvoiceConfigDataURL = (invoiceId) => {
  return `/customer/customer-invoice-configuration/view_config/?id=${invoiceId}`;
};

export const fetchInvoiceTemplateContentOptionsURL = (invoiceConfigId) => {
  return `/customer/customer-invoice-configuration/template_initial_data/?invoice_config_id=${invoiceConfigId}`;
};

export const deleteInvoiceConfigsURL = () => {
  return `/customer/customer-invoice-configuration/delete-config/`;
};
export const uploadOrderDocumentsURL = () => {
  return `/general/bulk_upload`;
};
export const getDocumentOptionsURL = () => {
  return `/trip/download-order-document`;
};
export const getDocumentTripOptionsURL = () => {
  return `/trip/download-falcon-document`;
};
export const fetchRegularizationTrackURL = (page, search) => {
  return `/customer/customer-regularization/track/?page=${page}${search}`;
};
